{
    "CodeList_Column_Description": "Descrição",
    "CodeList_Column_Code": "Código",
    "CodeList_Column_Type": "Tipo",
    "CodeList_Column_TelSys": "Servidor de telefonia",
    "CodeList_Column_Partition": "Partição",
    "CodeList_Partition_Any": "Qualquer",
    "CodeList_Scope_All": "Todos",
    "CodeList_Scope_ServiceWide": "Serviço em geral",
    "CodeList_Scope_SystemWide": "Em todo o sistema",
    "CodeList_Scope_Detached": "Desapegado",
    "CodeList_Type_All": "Todos",
    "CodeList_Type_Account": "Conta",
    "CodeList_Type_ACD_NotAvailable": "ACD não disponível",
    "CodeList_Scope_Label": "Escopo",
    "CodeList_Type_Label": "Tipo",
    "CodeList_Change_AnyPartitionNotSupported": "Os códigos em qualquer partição não podem ser editados ou visualizados aqui. Filtre a lista por uma partição específica para alterar ou visualizar um código.",
    "NAME": "Linguagem de lista de códigos"
}